"use strict";
'use es6';
/**
 * Flag enum of Design Asset Types.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = Object.freeze({
  NONE: 0,
  LAYOUT: 1,
  TEMPLATE: 2,
  CUSTOM_WIDGET: 4,
  GLOBAL_GROUP: 8,
  GLOBAL_WIDGET: 16
});

exports.default = _default;
module.exports = exports.default;